import { TFormId, TPTKMId } from "../Interfaces/AdminInterface"

/**
 * Scrolls into view an admin panel form,
 * if it has been rendered.
 *
 * Function does not have a test function,
 * works, though, if the form has been rendered
 * with the correct id.
 */
export default function scrollToAdminPanelForm(formId: TFormId | TPTKMId) {
	document.getElementById(formId)?.scrollIntoView()
}
